import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, List, message, Modal, Input } from "antd";
import { useTranslation } from "react-i18next";
import { connect } from "dvajs";
import { ListItem, Loading } from "@jd/focus-desktop-comps";
import { openUserCardModal } from "../../AddressBook/common";
import { debounce, trim as lodashTrim, uniqBy } from "lodash";
import IconFont, { IconSearch } from "../../icon";
import "./index.less";
import { ListItemData } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { searchContact } from "@/api/search";
import { getDeptPositionDesc } from "@/models/user";
import { changeEgovUrl } from "@/utils/tools";
import { LoadMore } from "@jd/focus-desktop-comps/lib/es/List";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import { checkTelephone } from "@/utils/chat";

const pageSize = 50;

function ContactModal({
  createModalVisible,
  openCreateContactModal,
  createModalInputValue,
  setCreateModalInputValue
}: {
  createModalVisible: boolean;
  openCreateContactModal: Function;
  createModalInputValue: string;
  setCreateModalInputValue: Function;
}) {
  const { t } = useTranslation("common");
  const { t: chatT } = useTranslation("chat");
  const [contactList, setContactList] = useState<ListItemData[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState(createModalInputValue);
  const [hasMore, setHasMore] = React.useState(false);
  const [needMask, setNeedMask] = React.useState(false);
  const pageNoRef = React.useRef<number>(1);

  function cancelHandler() {
    openCreateContactModal({ visible: false });
  }
  useEffect(() => {
    if (!createModalVisible) {
      setSearchValue("");
      setContactList(null);
      pageNoRef.current = 1;
      setNeedMask(false);
    }
    if (searchValue) {
      setCreateModalInputValue("");
    }
    if (checkTelephone(searchValue)) {
      setNeedMask(true);
    } else {
      setNeedMask(false);
    }
  }, [createModalVisible, searchValue, setCreateModalInputValue]);

  const handleSearch = useCallback(() => {
    if (!searchValue) {
      return;
    }
    setLoading(true);
    searchContact({
      keyword: searchValue,
      pageNo: pageNoRef.current,
      pageSize: pageSize
    })
      .then((res: any) => {
        if (!res) {
          setContactList([]);
          return;
        }

        const data: any = (res.contactList || []).map((item: any) => {
          return {
            ...item,
            id: item?.titleId,
            name: item?.realName,
            avatar: item?.avatar,
            desc:
              item.concatsType === 0
                ? item?.unitName
                : getDeptPositionDesc({
                  deptName: item?.deptName || "",
                  titleName: item?.titleName || "",
                  unitName: item?.unitName || "",
                  userType: item?.userType
                }),
            isLeader: item?.isleader,
            labelInfoList: item?.labelInfoList || [],
            concatsType: item.concatsType // 跨平台接口人类型, -1: 默认值，正常账号, 0: 跨平台法人单位接口人，1：跨平台单位公用账号接口人
          };
        });

        const newContacts = contactList ? [...contactList, ...data] : data;
        setContactList(
          uniqBy(newContacts, (item: any) => {
            return item.userId + item.app + item.teamId;
          })
        );
        setHasMore(res.contactList?.length >= pageSize);
      })
      .catch(async (e) => {
        const netServer = NetworkCheck.getInstance({
          url: getNetCheckUrl(),
          checkType: UseCheckType.API
        });
        const onLine = await netServer.checkNet();
        if (onLine) {
          message.error({
            content: `${e}`
          });
        } else {
          message.error(t("Network Error"));
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [contactList, searchValue, t]);

  useEffect(() => {
    if (createModalInputValue) {
      setSearchValue(createModalInputValue);
      handleSearch();
    }
  }, [createModalInputValue, handleSearch]);

  let loadMore = null;
  if (hasMore) {
    loadMore = (
      <LoadMore
        onClick={() => {
          pageNoRef.current = pageNoRef.current + 1;
          handleSearch();
        }}
      >
        {t("list.loadMore")}
      </LoadMore>
    );
  } else {
    loadMore = <LoadMore>{t("list.noMore")}</LoadMore>;
  }

  return (
    <Modal
      title={t("createButton.addContact")}
      width="480px"
      bodyStyle={{ width: 480, maxHeight: 340, padding: 24, minHeight: 46 }}
      visible={createModalVisible}
      footer={null}
      onCancel={cancelHandler}
      centered={true}
    >
      <div
        className="addContact-wrap"
        style={{ minHeight: contactList && contactList.length > 0 ? "auto" : "72px" }}
      >
        <div className="addContactSearchInput ">
          <div className="search-contact-container-input">
            <Input
              prefix={<IconFont type="iconapp_ic_search" style={{ color: "#848484" }} />}
              placeholder={t("search.iconTextContact")}
              className="input-box"
              value={searchValue}
              allowClear
              onChange={(e) => {
                pageNoRef.current = 1;
                setContactList(null);
                setSearchValue(e.target.value);
              }}
              maxLength={100}
              onPressEnter={handleSearch}
            />
          </div>
          <Button
            className="addContact-btn"
            type="primary"
            // loading={loading}
            onClick={handleSearch}
            disabled={!searchValue}
          >
            {t("search.iconText")}
          </Button>
        </div>
        <div className="contact-body">
          {loading && <Loading style={{ marginTop: 10 }} />}
          {contactList ? (
            contactList.length > 0 ? (
              // contactList.length > 0 ? (
              //     contactList?.map((item, key) => {
              //         let newItem = item;
              //         if (newItem.avatar) {
              //             newItem.avatar = changeEgovUrl(newItem.avatar);
              //         }
              //         return (
              //             <div key={key}>

              //                 <ListItem
              //                     data={newItem}
              //                     onClick={debounce(() => {
              //                         openUserCardModal(item);
              //                     }, 500)}
              //                 />
              //             </div>
              //         );
              //     })

              <List
                dataSource={contactList || []}
                loadMore={loadMore}
                renderItem={(item: any) => {
                  let newItem = item;
                  if (newItem.avatar) {
                    newItem.avatar = changeEgovUrl(newItem.avatar);
                  }
                  return (
                    <ListItem
                      data={newItem}
                      onClick={debounce(() => {
                        let needMaskName = false;
                        if (item.concatsType === 0) needMaskName = true;
                        openUserCardModal({ ...item, needMask, needMaskName });
                      }, 500)}
                    />
                  );
                }}
              />
            ) : (
              <div className="contact-nodata">
                <h4>无法找到该用户</h4>
                <p>
                  1、仅支持精准搜索姓名或手机号，如“张三”或者“13800000000”，请检查关键词是否输入正确
                  <br />
                  2、对方可能未使用{(window as any)?._BTS_CONFIG?.REACT_APP_NAME || process.env.REACT_APP_NAME || ""}或因隐私设置无法被搜索
                </p>
              </div>
            )
          ) : (
            ""
          )}
        </div>
      </div>
    </Modal>
  );
}
function mapStateToProps({ ebook }: any) {
  return {
    createModalVisible: ebook.createModalVisible,
    createModalInputValue: ebook.createModalInputValue
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateContactModal(data: any) {
      dispatch({ type: "ebook/openCreateContactModal", payload: data });
    },
    setCreateModalInputValue(data: any) {
      dispatch({ type: "ebook/setCreateModalInputValue", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactModal);
